module.exports = __webpack_public_path__ + "img/673.e4a2b8b8.png";